<!-- <h4 class="title">Follow up Save</h4> -->
<mat-icon style="text-align: left;width: 100%;margin-bottom: 13px;margin-top: -10px;" mat-button (click)="close()">arrow_back_ios</mat-icon>

<div class="row">
    <div class="col-md-12">
        <h4 class="title-f">Field Visit Follow Up</h4>
        <div class="card-box">
            <!-- <h4 class="title-f">Account Summary</h4> -->
            <div class="row" style="padding: 0px 0px 23px 10px;">
                <div class="col-md-3">
                    <h5 class="form-lable">Action Type:</h5>
                    <input type="text" pInputText placeholder="" >
                </div>
                <div class="col-md-3">
                    <h5 class="form-lable">Action Code:</h5>
                    <input type="text" pInputText placeholder="" >
                </div>
                <div class="col-md-3">
                    <h5 class="form-lable">Next Action Type:</h5>
                    <input type="text" pInputText placeholder="" >
                </div>
                <div class="col-md-3">
                    <h5 class="form-lable">Planned Date:</h5>
                    <input type="text" pInputText placeholder="" >
                </div>
                <div class="col-md-3">
                    <h5 class="form-lable">Action Description :</h5>
                    <input type="text" pInputText placeholder="" >
                </div>
                <div class="col-md-3">
                    <h5 class="form-lable">Result Description :</h5>
                    <input type="text" pInputText placeholder="" >
                </div>
                <div class="col-md-3">
                    <h5 class="form-lable">Next Action Description:</h5>
                    <input type="text" pInputText placeholder="" >
                </div>
                <div class="col-md-3">
                    <h5 class="form-lable">Pickup Required:</h5>
                    <input type="text" pInputText placeholder="" >
                </div>
                <div class="col-md-3">
                    <h5 class="form-lable">Field Visit for:</h5>
                    <input type="text" pInputText placeholder="" >
                </div>
                <div class="col-md-3">
                    <h5 class="form-lable">Address Type:</h5>
                    <input type="text" pInputText placeholder="" >
                </div>

                <div class="col-md-3">
                    <h5 class="form-lable">Address:</h5>
                    <input type="text" pInputText placeholder="" >
                </div>
                <div class="col-md-3">
                    <h5 class="form-lable">Phone Ext:</h5>
                    <input type="text" pInputText placeholder="" >
                </div>
                <div class="col-md-3">
                    <h5 class="form-lable">Mobile :</h5>
                    <input type="text" pInputText placeholder="" >
                </div>
                <div class="col-md-3">
                    <h5 class="form-lable">Contact Person:</h5>
                    <input type="text" pInputText placeholder="" >
                </div>
                <div class="col-md-3">
                    <h5 class="form-lable">Requested Date:</h5>
                    <input type="text" pInputText placeholder="" >
                </div>
                <div class="col-md-3">
                    <h5 class="form-lable">Amount:</h5>
                    <input type="text" pInputText placeholder="" >
                </div>
                <div class="col-md-12">
                    <h5 class="form-lable">Notes:</h5>
                    <textarea pInputTextarea></textarea>
                </div>
                <div class="col-md-3 mt-20">
                  <button type="button" class="btn btn-primary">Save</button>
             </div>

            </div>

            
        </div>
    </div>
</div>


<a (click)="table_v = !table_v" class="link-a">View Field Visit History</a>
<ng-container *ngIf="table_v == true">

    <h4 class="title">Field Visit History</h4>

    <div class="doc-table">
        <div class="card-box"> <p-table [value]="rows | filter:searchQR" styleClass="ui-table-customers" #tt [paginator]="false" [rows]="5"
            [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]" [showCurrentPageReport]="true"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [globalFilterFields]="['type']">
            <ng-template pTemplate="header">
                <tr style="text-align: center;">
                    <th>S.No</th>
                    <th>Requested Date</th>
                    <th>Field Visit for</th>
                    <th>Address Type</th>
                    <th>Address</th>
                    <th>Phone Ext</th>
                    <th>Mobile</th>
                    <th>Contact Person</th>
                    <th>Amount</th>
                    <th>Field Visit Date</th>
                    <th>Customer Available </th>
                    <th>Payment Made</th>
                    <th>Amount Collected</th>
                    <th>Status</th>
                    <th>Receipt Number</th>
                    <th>Next Action</th>
                     <th>Next Action Date</th>
                     <th>Remarks</th>
                </tr>
                <tr style="text-align: center;">
                    <td>1</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
            </ng-template>
         </p-table>  </div>
    </div>
    <br>

</ng-container>
